// shelbulaworkspaces/RenameFileModal.jsx
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Loader, Edit } from 'lucide-react';

const RenameFileModal = ({ isOpen, onClose, onConfirm, fileNode }) => {
    const [newName, setNewName] = useState('');

    useEffect(() => {
        if (fileNode) {
            setNewName(fileNode.name);
        }
    }, [fileNode]);

    if (!isOpen || !fileNode) return null;

    const handleConfirm = () => {
        const parentPath = fileNode.path.substring(0, fileNode.path.lastIndexOf('/') + 1);
        const newPath = parentPath + newName;
        onConfirm(fileNode.path, newPath);
    };

    return ReactDOM.createPortal(
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        className="relative w-full max-w-md bg-surface rounded-lg border border-border-color shadow-xl"
                    >
                        <div className="p-6">
                            <h2 className="text-lg font-bold text-on-surface flex items-center gap-2"><Edit size={20} />Rename File/Folder</h2>
                            <p className="text-sm text-on-surface-dim mt-2">Enter the new name for <strong className="text-on-surface font-mono">{fileNode.name}</strong>.</p>
                            
                            <input
                                type="text"
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                                className="w-full mt-4 px-3 py-2 bg-background-dark border border-border-color rounded-md text-on-surface focus:ring-2 focus:ring-primary focus:outline-none"
                            />
                             <div className="mt-6 flex justify-end gap-3">
                                <button onClick={onClose} className="px-4 py-2 text-sm font-semibold rounded-md text-on-surface hover:bg-surface-dark transition-colors">
                                    Cancel
                                </button>
                                <button 
                                    onClick={handleConfirm}
                                    disabled={!newName || newName === fileNode.name}
                                    className="px-4 py-2 text-sm font-semibold rounded-md bg-primary text-white disabled:bg-primary/50 disabled:cursor-not-allowed hover:bg-primary-dark transition-colors"
                                >
                                    Rename
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default RenameFileModal;